import React from 'react';
export function CampaignHero() {
  return <section className="relative min-h-screen flex items-center" data-id="element-28">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
      backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/o4GXUUY6zJVJnviH8ocAoU/Background.png')`
    }} data-id="element-29" />

      <div className="relative w-full max-w-7xl mx-auto px-8 pt-10" data-id="element-30">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-31">
          {/* Left Content */}
          <div className="space-y-8" data-id="element-32">
            <div className="space-y-6" data-id="element-33">
              <h1 className="text-5xl lg:text-6xl font-bold text-blue-800 leading-tight" data-id="element-34">
                WE ALL DO BETTER WHEN
                <br data-id="element-35" />
                WE ALL DO BETTER.
              </h1>

              <div className="w-24 h-1 bg-blue-700" data-id="element-36" />
            </div>

            <div className="space-y-6 text-blue-800" data-id="element-37">
              <p className="text-xl leading-relaxed font-light" data-id="element-38">
                But for too long, our local politics have been stuck in the
                past.
              </p>
              <p className="text-xl leading-relaxed font-light" data-id="element-39">
                It is up to us to be brave enough to meet the moment on issues ranging from 
                the rising cost of housing and healthcare to a rigged tax code that benefits 
                the billionaires and well-connected while hurting ordinary people.
               </p>
              <p className="text-xl leading-relaxed font-light" data-id="element-40">
                It is for those reasons and more
                that I am considering running for Cuyahoga County Council,
                District 3.
              </p>
              <p className="text-xl leading-relaxed font-semibold pb-4" data-id="element-41">
                Because I know in my bones that we can do better together.
              </p>
              <p className="text-xl leading-relaxed font-light" data-id="element-42">
                - Justin Strekal
              </p>
            </div>

            <div className="flex justify-center" data-id="element-43">
              <a href="https://secure.actblue.com/donate/justinforus" data-id="element-44">
                <button className="bg-red-600 hover:bg-red-700 text-white font-bold text-xl px-12 py-4 transition-colors" data-id="element-45">
                  DONATE
                </button>
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="flex justify-center lg:justify-end" data-id="element-46">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qp1gPBCktapG2qPWotrmXg/CandidatePhoto.png" alt="Justin - Candidate" className="w-full max-w-lg h-auto object-contain" data-id="element-47" />
          </div>
        </div>
      </div>
    </section>;
}